<template>
	<div class="row">
		<div class="col-md-12">
			<!--			<div class="box-tools pull-right" v-if="currentIndex > 0">-->
			<!--				<button @click="removePayment(currentIndex)" type="button" class="btn btn-box-tool remove_payment_row"><i class="fa fa-times fa-2x"></i></button>-->
			<!--			</div>-->
			<!--			<div class="clearfix"></div>-->
			<div class="box-body-payment">

				<b-form-group>

					<b-row>
						<b-col sm="12" class="mb-2">
							<label for="">{{$t('xAtchot.title')}}:</label>
							<b-input-group>
								<b-input-group-text
									slot="prepend"
									style="cursor: pointer;"
									@click="giveTotalSumToPayment('CASH')"
								>
									<span>{{ saleCurrencyName }}</span>
								</b-input-group-text>
								<b-form-input
									ref="CASH"
									:placeholder="$t('pos.amountOfMoney')"
									v-model="payments.find(el => el.paymentMethod.code == 'CASH').amount"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									type="number"
									:state="totalPaid >= parseFloat(totalSum)-parseFloat(payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0)
																			-parseFloat(payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0)"
								></b-form-input>
							</b-input-group>
						</b-col>
						<!--<b-col sm="12" class="mb-2">
							<label for="">{{$t('xAtchot.cart')}}:</label>
							<b-input-group>
								<b-input-group-text
									slot="prepend"
									style="cursor: pointer;"
									@click="giveTotalSumToPayment('BANK_CARD')"
								>
									<span>$</span>
								</b-input-group-text>
								<b-form-input
									ref="BANK_CARD"
									:placeholder="$t('pos.amountOfMoney')"
									v-model="payments.find(el => el.paymentMethod.code == 'BANK_CARD').amount"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									type="number"
									:state="totalPaid >= parseFloat(totalSum)-parseFloat(payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0)
																			-parseFloat(payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0)"
								></b-form-input>
							</b-input-group>
						</b-col>-->
						<b-col sm="12" class="mb-2">
							<label for="">{{$t('pos.bankTransfer')}}:</label>
							<b-input-group>
								<b-input-group-text
									slot="prepend"
									style="cursor: pointer;"
									@click="giveTotalSumToPayment('BANK_TRANSFER')"
								>
									<span>{{ saleCurrencyName }}</span>
								</b-input-group-text>
								<b-form-input
									ref="BANK_TRANSFER"
									:placeholder="$t('pos.amountOfMoney')"
									v-model="payments.find(el => el.paymentMethod.code == 'BANK_TRANSFER').amount"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									type="number"
									:state="totalPaid >= parseFloat(totalSum)-parseFloat(payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0)
																			-parseFloat(payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0)"
								></b-form-input>
							</b-input-group>
						</b-col>
						<!-- WITH_DOCUMENT CHECKBOX -->
						<!--						<b-col sm="12" class="mb-1 mt-1">-->
						<!--							<b-form-checkbox-->
						<!--								id="checkbox-withDocument"-->
						<!--								v-model="withDocument"-->
						<!--								name="checkbox-withDocument"-->
						<!--								class="d-flex align-items-center"-->
						<!--							>-->
						<!--								{{$t('pos.withDocument')}}-->
						<!--							</b-form-checkbox>-->
						<!--						</b-col>-->
						<!-- DEBT CHECKBOX -->
						<b-col sm="12" class="mb-1 mt-1">
							<b-form-checkbox
								id="checkbox-dept"
								v-model="isDebt"
								name="checkbox-debt"
								class="d-flex align-items-center"
							>
								{{$t('xAtchot.debt')}}
							</b-form-checkbox>
						</b-col>
						<b-col v-if="isDebt" sm="12" class="mb-2">
							<label for="">{{$t('sale.debt-money')}}:</label>
							<b-input-group>
								<b-input-group-text
									slot="prepend"
									style="cursor: pointer;"
									@click="giveTotalSumToPayment('QARZGA')"
								>
									<span>{{ saleCurrencyName }}</span>
								</b-input-group-text>
								<b-form-input
									:placeholder="$t('pos.amountOfMoney')"
									ref="QARZGA"
									v-model="payments.find(el => el.paymentMethod.code == 'QARZGA').amount"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									@input="handleInputMoney($event, 'QARZGA')"
									type="number"
									:state="totalPaid >= parseFloat(totalSum)-parseFloat(payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0)
																			-parseFloat(payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0)"
								></b-form-input>
							</b-input-group>
						</b-col>
						<!-- CERTIFICATE CHECKBOX -->
						<b-col sm="12" class="mb-1 mt-1">
							<b-form-checkbox
								id="checkbox-1"
								v-model="isCertificate"
								name="checkbox-1"
								class="d-flex align-items-center"
							>
								{{$t('xAtchot.certificate')}}
							</b-form-checkbox>
						</b-col>
						<b-col v-if="isCertificateComputed" sm="12" class="mb-2">
							<label for="">
								{{$t('certificate.editTitle')}} № <span
								v-if="certificateForPos">{{certificateForPos.certificateNumber}}</span>:
								<span style="color: red;"
									  v-if="certificateError">{{ $t('pos.certificateNotFound') }}</span>
								<span v-if="certificateForPos && certificateForPos.type == 'MONEY'"
									  style="font-weight: normal;">Остоток = <span style="color: green;">{{certificateForPos.balance | currency({symbol: userDepCurrencyName,
										symbolPosition: 'back', thousandsSeparator: ' ', fractionCount: 0,})}}</span></span>
							</label>
							<b-input-group>
								<b-input-group-text slot="prepend"
													:style="[certificateLoading ? {'padding': '.375em 0.55em'} : {}]">
									<b-spinner v-if="certificateLoading" small variant="primary"
											   label="Small Spinner"></b-spinner>
									<span v-else>#</span>
								</b-input-group-text>
								<b-form-input
									ref="certificateRef"
									:placeholder="$t('certificate.number')"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									@keyup.enter.native="getCertificateForPayment"
									:state="payments.find(el => el.paymentMethod.code == 'CERTIFICATE').certificate.length == 4 && !certificateError"
									v-model="payments.find(el => el.paymentMethod.code == 'CERTIFICATE').certificate"
								></b-form-input>
							</b-input-group>

						</b-col>
						<b-col v-if="isCertificateComputed" sm="12" class="mb-2">
							<label for="">{{$t('sale.money-pay')}}:</label>
							<b-input-group>
								<b-input-group-text
									slot="prepend"
									style="cursor: pointer;"
									@click="giveTotalSumToPayment('CERTIFICATE')"
								>
									<span>{{ saleCurrencyName }}</span>
								</b-input-group-text>
								<b-form-input
									ref="CERTIFICATE"
									:placeholder="$t('pos.amountOfMoney')"
									v-model="payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									@input="handleInputMoney($event, 'CERTIFICATE')"
									type="number"
									:disabled="!certificateForPos || certificateForPos.balance == 0"
									:state="totalPaid >= parseFloat(totalSum)-parseFloat(payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0)
																			-parseFloat(payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0)"
								></b-form-input>
							</b-input-group>
						</b-col>
						<!--<b-col sm="12" class="mb-1 mt-1">
							<b-form-checkbox
								id="checkbox-sponsor"
								v-model="isSponsor"
								name="checkbox-sponsor"
								class="d-flex align-items-center"
							>
								{{$t('sidebar.sales.sponsor')}}
							</b-form-checkbox>
						</b-col>
						<b-col v-if="isSponsor" sm="12" class="mb-2">
							<label for="">{{$t('pos.sum')}} {{$t('sales.sponsor')}}:</label>
							<b-input-group>
								<b-input-group-text
									slot="prepend"
									style="cursor: pointer;"
									@click="giveTotalSumToPayment('HOMIYLIK')"
								>
									<span>$</span>
								</b-input-group-text>
								<b-form-input
									:placeholder="$t('pos.amountOfMoney')"
									ref="HOMIYLIK"
									v-model="payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount"
									@click="$event.target.select()"
									@focus="$event.target.select()"
									@input="handleInputMoney($event, 'HOMIYLIK')"
									type="number"
									:state="totalPaid >= parseFloat(totalSum)-parseFloat(payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0)
																			-parseFloat(payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0)"
								></b-form-input>
							</b-input-group>
						</b-col>-->

						<!--<b-col sm="5">
							<label for="">Payment Method:</label>
							<b-row>
								<b-col>
									<b-form-select
										v-model="payment.paymentMethod"
										@change="setSertificate"

									>
										<option v-for="(selectOption, indexOpt) in allPaymentMethods"
												:key="indexOpt"
												:value="selectOption"
										>
											{{ selectOption.code }}
										</option>
										<template slot="first">
											<option :value="null" disabled>&#45;&#45; Payment Method &#45;&#45;</option>
										</template>
									</b-form-select>

								</b-col>
							</b-row>
						</b-col>
						<b-col sm="2">
							<b-row>
								<b-col>
									<div class="box-tools pull-right" v-if="currentIndex > 0">
										<button @click="removePayment(currentIndex)" type="button"
												class="btn btn-box-tool remove_payment_row"><i
											class="fa fa-times fa-2x"></i></button>

									</div>
								</b-col>
							</b-row>
						</b-col>-->
						<b-col sm="12" class="mt-2">
							<button @click="openPriceListModal" type="button"
									class="btn btn-success remove_payment_row"><i class="fa fa-print fa-2x"> {{ $t('price_list')}}</i></button>
						</b-col>

						<b-col sm="12" class="mt-1 pt-6"
							   :style="[(isCertificateComputed || isDebt || isSponsor) ? {'padding-top': '0'} : {'padding-top': '124px'}]">
							<label for="">{{$t('sale.sale')}}</label>
							<b-form-textarea
								id="textarea"
								v-model="paymentComment"
								:placeholder="$t('sale.sale')"
								:rows="rows"
								max-rows="5"
							></b-form-textarea>

						</b-col>

						<b-modal
							v-model="showPriceList"
							size="lg"
							hide-footer
							:no-close-on-esc="true"
							:no-close-on-backdrop="true"
						>
							<template slot="modal-header" class="addItemsModalHeader">
								<button
									type="button"
									class="close right"
									data-dismiss="modal"
									aria-label="Close"
									@click="closePriceListModal"
								>
									<i class="fa fa-times sm"></i>
								</button>
							</template>

							<div id="section-to-print">

								<table class="table b-table table-striped table-hover table-bordered" id="tbssslData">
									<thead>
									<tr>
										<th>ID</th>
										<th>{{ $t('goods.artikul')}}</th>
										<th>{{ $t('goods.color')}}</th>
										<th>{{ $t('goods.name')}}</th>
										<th>{{ $t('incomes.create.count')}}</th>
										<th>{{ $t('prices.item.lastPriceWholesale')}}</th>
										<th>{{ $t('prices.item.lastPriceUzs')}}</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="item,index in priceListItems.items">
										<td>{{index + 1}}</td>
										<td>{{item.artikul}}</td>
										<td>{{item.color}}</td>
										<td>{{item.name}}</td>
										<td class="text-center">{{item.count}}</td>
										<td class="text-center">{{item.priceWholesale | currency({
											symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}</td>
										<td class="text-center">{{item.priseUzs | currency({
											symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}</td>

									</tr>
									</tbody>
									<tfoot>
									<tr>
										<td class="text-right" colspan="4"><b>TOTAL: &nbsp;</b> </td>
										<th class="text-center">{{ totalCount() }}</th>
										<th class="text-center">{{priceListItems.totalPriceWholeSale | currency({
											symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}</th>
										<th class="text-center">{{priceListItems.totalPriceUzs | currency({
											symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}</th>
									</tr>
									</tfoot>
								</table>
								<hr>

								<div class="row top mt-3 justify-content-end">
									<div class="col-3">
										<b-button variant="outline-danger" size="sm" block
												  @click="closePriceListModal">
											{{$t('actions.cancel')}}
										</b-button>
									</div>
									<div class="col-3">
										<b-button variant="outline-success" size="sm" block @click="print('tbssslData')">
											{{$t('Excel')}}
										</b-button>
									</div>
									<div class="col-3">
										<b-button variant="outline-success" size="sm" block @click="printPdf">
											{{$t('PDF')}}
										</b-button>
									</div>
								</div>
							</div>
						</b-modal>

					</b-row>
				</b-form-group>

			</div>
		</div>
	</div>

</template>


<script>
	import {mapState, mapActions} from 'vuex'
	import Vue from 'vue'
	import {TokenService} from '../../../../../../services/storage.service'

	export default {
		name: 'PaymentMethod',
		props: ['totalSum', 'openClicked', 'saleCurrencyName', 'allItems'],
		data: () => {
			return {
				rows: 5,
				/*dropdowns: {
					allMethods: []
				},*/
				isCertificate: false,
				isDebt: false,
				isSponsor: false,
				withDocument: false,
				payments: [],
				paymentComment: '',
				lastDebtInput: '',
				lastSponsorInput: '',
				lastElementCode: 'CASH',
				confirmLastElementCode: 'CASH',
				showPriceList: false,
				documentItems: [],


			}
		},
		computed: {
			...mapState([
				'userDepCurrencyName'
			]),
			...mapState('wholesalePos', [
				'withDocumentStore', 'priceListItems'
			]),
			...mapState('references', [
				'allPaymentMethods'
			]),
			...mapState('certificates', [
				'certificateForPos', 'certificateError', 'certificateLoading'
			]),

			isCertificateComputed() {
				return this.isCertificate;
			},
			fields() {
				return [
					{
						key: 'id',
						label: 'id',
					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
					},
					{
						key: 'color',
						label: this.$t('goods.color'),
					},
					{
						key: 'name',
						label: this.$t('goods.name'),
					},
					{
						key: 'priceWholesale',
						label: this.$t('prices.item.lastPriceWholesale')
					},
					{
						key: 'priseUzs',
						label: this.$t('prices.item.lastPriceUzs')
					},


				]
			},
			totalPaid() {
				return this.payments.reduce(function (prev, cur) {
					if (cur.amount.toString().trim() !== '' && cur.paymentMethod.code !== 'QARZGA' && cur.paymentMethod.code !== 'HOMIYLIK') {
						return prev + parseFloat(cur.amount);
					} else {
						return prev
					}
				}, 0);
			},
			computedDebtAmount() {
				if (this.payments.length > 0) {
					return this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0;
				}
				return 0;
			},
			computedSponsorshipAmount() {
				if (this.payments.length > 0) {
					return this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0;
				}
				return 0;
			}
		},
		async mounted() {
			await this.loadPaymentMethods()
			await this.addNewPayment();
			// this.dropdowns.allMethods = this.allPaymentMethods;
		},
		created() {

		},
		watch: {
			withDocument: {
				handler(newVal) {
					if (newVal) {
						this.$store.commit('wholesalePos/changeWithDocument', true);
					} else {
						this.$store.commit('wholesalePos/changeWithDocument', false);
					}
				}
			},
			isCertificate: {
				handler(newBoolean) {
					if (newBoolean) {
						setTimeout(() => {
							this.$refs.certificateRef.focus();
						}, 100);
					} else {
						this.$store.commit('certificates/posCertificateError', {message: null})
						this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').certificate = '';
						this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount = 0;
					}
				}
			},
			computedDebtAmount: {
				handler() {
					this.$emit('debtAmountChanged', this.computedDebtAmount);
				}
			},
			computedSponsorshipAmount: {
				handler() {
					this.$emit('sponsorshipAmountChanged', this.computedSponsorshipAmount);
				}
			},
			isDebt: {
				handler(newBoolean) {
					if (newBoolean) {
						this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = parseFloat(this.totalSum) - this.totalPaid > 0 ? parseFloat(this.totalSum) - this.totalPaid : 0;
						this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = 0;
						setTimeout(() => {
							this.$refs.QARZGA.focus();
						}, 100);
					} else {
						this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = 0;
					}
				}
			},
			isSponsor: {
				handler(newBoolean) {
					if (newBoolean) {
						// this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = parseFloat(this.totalSum) - this.totalPaid > 0 ? parseFloat(this.totalSum) - this.totalPaid : 0;
						this.changePaymentAmounts('HOMIYLIK');
						setTimeout(() => {
							this.$refs.HOMIYLIK.focus();
						}, 100);
					} else {
						this.changePaymentAmounts('CASH');
						this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = 0;
						setTimeout(() => {
							this.$refs.CASH.focus();
						}, 100);
					}
				}
			},
			openClicked: {
				handler(newVal) {
					if (newVal) {
						this.isCertificate = false;
						this.isDebt = false;
						this.isSponsor = false;
						this.paymentComment = '';
						if (this.allPaymentMethods.length > 1) {
							this.payments = [];
							this.addNewPayment();
						}
						setTimeout(() => {
							this.payments.find(el => el.paymentMethod.code == 'CASH').amount = parseFloat(this.totalSum);
							this.$refs.CASH.focus();
						}, 100);
					}
				}
			},
			payments: {
				handler: function (val, oldVal) {
					this.payments.forEach(el => {
						if (this.certificateForPos) {
							if (el.paymentMethod.code == 'CERTIFICATE' && el.amount.toString().trim() !== '') {
								if (parseFloat(el.amount) > parseFloat(this.certificateForPos.balance)) {
									el.amount = this.certificateForPos.balance;
								} else if (el.amount < 0) {
									el.amount = 0;
								}
							}
						}
                        if (el.paymentMethod.code == 'BANK_TRANSFER' && el.amount.toString().trim() !== '') {
                            this.$store.commit('wholesalePos/changeWithDocument', parseFloat(el.amount) > 0);
                            this.withDocument = parseFloat(el.amount) > 0;
                        } else {
                            this.$store.commit('wholesalePos/changeWithDocument', false);
                            this.withDocument = false;
						}
					});
					if (parseFloat(this.totalPaid) >= parseFloat(this.totalSum)) {
						Vue.set(this.payments.find(el => el.paymentMethod.code == 'QARZGA'), 'amount', 0);
					}
				},
				deep: true
			}
		},
		methods: {
			...mapActions('references', [
				'loadPaymentMethods'
			]),
			...mapActions('certificates', [
				'getCertificateByNumber'
			]),
			...mapActions('wholesalePos', [
				'setDefaultPriceListItems', 'getPriceListItems'
			]),
			totalCount(){
				let count = 0;
				if(this.priceListItems.items){
					this.priceListItems.items.forEach(item => {
						count += parseInt(item.count)
					});
				}
				return count;
			},
			printPdf(){
				window.print();
			},
			print(table, filename = '') {

				var uri = 'data:application/vnd.ms-excel;base64,',
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
					, base64 = function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					};
				if (!table.nodeType) table = document.getElementById(table);
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
				window.location.href = uri + base64(format(template, ctx));
			},
			async openPriceListModal() {
				let sendObject = {};
				sendObject.depId = localStorage.getItem('dep_id');
				sendObject.items = [];
				this.allItems.forEach(item => {
					sendObject.items.push({id: item.itemId, count: item.count})
				});
				await this.getPriceListItems(sendObject);
				this.showPriceList = true;
			},
			async closePriceListModal() {
				await this.setDefaultPriceListItems(false);
				this.showPriceList = false;
			},
			addNewPayment() {
				for (let i = 0; i < this.allPaymentMethods.length; i++) {
					let obj = {
						amount: 0,
						paymentMethod: this.allPaymentMethods[i],
						certificate: '',
						certificateId: null,
						text: ''
					}
					this.payments.push(obj)
				}
			},
			async getCertificateForPayment() {
				let certificateNumber = this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').certificate;
				if (certificateNumber.length == 4) {
					this.$store.commit('certificates/setCertificateLoading', true);
					await this.getCertificateByNumber(certificateNumber)
					if (this.certificateError) {
						this.$store.commit('certificates/resetCertificateForPos')
						this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount = 0;
						this.$refs.certificateRef.$el.setSelectionRange(0, this.$refs.certificateRef.$el.value.length)
					} else if (this.certificateForPos) {
						this.$refs.CERTIFICATE.focus()
					}
				} else {
					this.$vs.notify({
						title: 'Номер сертификата должен быть четырехзначным',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.$store.commit('certificates/posCertificateError', {message: null})
					this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount = 0;
					this.$refs.certificateRef.$el.setSelectionRange(0, this.$refs.certificateRef.$el.value.length)
				}
			},
			giveTotalSumToPayment(paymentMethodCode) {
				if (paymentMethodCode == 'CERTIFICATE') {
					if (this.certificateForPos) {
						if (parseFloat(this.certificateForPos.balance) >= parseFloat(this.totalSum)) {
							this.changePaymentAmounts(paymentMethodCode);
							this.confirmLastElementCode = paymentMethodCode;
							this.lastElementCode = paymentMethodCode;
							// this.$refs[paymentMethodCode].$el.setSelectionRange(0, this.$refs[paymentMethodCode].$el.value.length)
						}
						this.$refs[paymentMethodCode].focus();
					} else {
						this.$refs.certificateRef.focus();
					}
				} else {
					this.changePaymentAmounts(paymentMethodCode);
					this.confirmLastElementCode = paymentMethodCode;
					this.lastElementCode = paymentMethodCode;
					this.$refs[paymentMethodCode].focus();
					// this.$refs[paymentMethodCode].$el.setSelectionRange(0, this.$refs[paymentMethodCode].$el.value.length)
				}
			},
			changePaymentAmounts(paymentMethodCode) {
				this.payments.forEach(payment => {
					if (payment.paymentMethod.code == paymentMethodCode) {
						payment.amount = this.totalSum;
					} else {
						payment.amount = 0;
					}
				})
			},
			handleInputMoney($event, paymentMethodCode) {
				/** --FOR QARZGA-- **/
				if (paymentMethodCode == 'QARZGA') {
					if ($event.trim() !== '') {
						this.payments.forEach(el => {
							if (parseFloat(el.amount) >= parseFloat(this.totalPaid)) {
								if (el.paymentMethod.code !== 'QARZGA' && parseFloat(this.totalSum) >= parseFloat($event)) {
									if (this.lastElementCode == this.confirmLastElementCode && el.paymentMethod.code == this.confirmLastElementCode) {
										Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalSum) - parseFloat($event))
										this.lastDebtInput = $event;
										this.lastElementCode = el.paymentMethod.code;
									}
								} else {
									this.confirmLastElementCode = this.lastElementCode
									Vue.set(this.payments.find(el => el.paymentMethod.code == 'QARZGA'), 'amount', parseFloat(this.lastDebtInput))
								}
							}
						});
						let foundIndex = this.payments.findIndex(el => {
							return el.amount > 0 && el.amount !== '' && el.paymentMethod.code !== 'QARZGA'
						});
						if (foundIndex == -1) {
							this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = $event;
						}
					} else {
						Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalPaid) + parseFloat(this.lastDebtInput))
					}
					if (parseFloat(this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ?
						this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount :
						0) > parseFloat(this.totalPaid)) {
						this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = parseFloat(this.lastDebtInput);
					}
				}
				/** --FOR HOMIYLIK-- **/
				/*if (paymentMethodCode == 'HOMIYLIK') {
					if ($event.trim() !== '') {
						this.payments.forEach(el => {
							if (parseFloat(el.amount) >= parseFloat(this.totalPaid)) {
								if (el.paymentMethod.code !== 'HOMIYLIK' && parseFloat(this.totalSum) >= parseFloat($event)) {
									if (this.lastElementCode == this.confirmLastElementCode && el.paymentMethod.code == this.confirmLastElementCode) {
										Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalSum) - parseFloat($event))
										this.lastSponsorInput = $event;
										this.lastElementCode = el.paymentMethod.code;
									}
								} else {
									this.confirmLastElementCode = this.lastElementCode
									Vue.set(this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK'), 'amount', parseFloat(this.lastSponsorInput))
								}
							}
						});
						let foundIndex = this.payments.findIndex(el => {
							return el.amount > 0 && el.amount !== '' && el.paymentMethod.code !== 'HOMIYLIK'
						});
						if (foundIndex == -1) {
							this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = $event;
						}
					} else {
						Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalPaid) + parseFloat(this.lastSponsorInput))
					}
					if (parseFloat(this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ?
						this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount :
						0) > parseFloat(this.totalPaid)) {
						this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = parseFloat(this.lastSponsorInput);
					}
				}*/
				/** --FOR CERTIFICATE-- **/
				/*if (paymentMethodCode == 'CERTIFICATE') {
					if ($event.trim() !== '') {
						this.payments.forEach(el => {
							if (parseFloat(el.amount) >= parseFloat(this.totalPaid)) {
								if (el.paymentMethod.code !== paymentMethodCode && parseFloat(this.totalSum) >= parseFloat($event)) {
									if (this.lastElementCode == this.confirmLastElementCode && el.paymentMethod.code == this.confirmLastElementCode) {
										Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalSum) - parseFloat($event))
										this.lastDebtInput = $event;
										this.lastElementCode = el.paymentMethod.code;
									}
								} else {
									this.confirmLastElementCode = this.lastElementCode
									Vue.set(this.payments.find(el => el.paymentMethod.code == paymentMethodCode), 'amount', parseFloat(this.lastDebtInput))
								}
							}
						});
						let foundIndex = this.payments.findIndex(el => {
							return el.amount > 0 && el.amount !== '' && el.paymentMethod.code !== paymentMethodCode
						});
						if (foundIndex == -1) {
							this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount = $event;
						}
					} else {
						Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalPaid) + parseFloat(this.lastDebtInput))
					}
					if (parseFloat(this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount !== '' ?
						this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount :
						0) > parseFloat(this.totalPaid)) {
						this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount = parseFloat(this.lastDebtInput);
					}
				}*/
			},
		}
	}
</script>

<style scoped lang="scss">
	.box-body-payment {
		margin-bottom: 10px;

		label {
			margin-bottom: 4px;
			font-size: 14px;
			font-weight: bold;
		}
	}

	@media print {
		body * {
			visibility: hidden;
		}
		#section-to-print, #section-to-print * {
			visibility: visible;
		}
		#section-to-print {
			position: absolute;
			left: 0;
			top: 0;
		}
	}

	.spinner-border {
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50% !important;
	}

	td .form-control {
		height: unset;
	}

	.fa-2x {
		font-size: 2em;
	}

	.btn-box-tool:hover {
		color: #606c84;
	}

	.btn-box-tool {
		padding: 5px;
		font-size: 20px;
		background: transparent;
		color: #97a0b3;
	}

	.fa {
		display: inline-block;
		font: normal normal normal 14px/1 FontAwesome;
		font-size: inherit;
		text-rendering: auto;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>
